// Styles
import "./app.scss";
// Tools
import { Route, Routes, Navigate } from "react-router-dom";
// Components
import { Auth } from "../pages/auth/Auth";
import { Main } from "../pages/main/Main";
import { MockPanel } from "../shared/components/mock-panel/MockPanel";

export const App = () => {
	return (
		<>
			<Routes>
				<Route path='/auth/*' element={<Auth />} />
				<Route path='/main/*' element={<Main />} />
				{/* Все остальные пути перенаправялем на auth */}
				<Route path='/' element={<Navigate to='/auth' replace />} />
				<Route path='*' element={<Navigate to='/auth' replace />} />
			</Routes>
			<MockPanel />
		</>
	);
};
